<template>
  <div>
    <Head title="Přidat komponentu" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/components">Komponenty</Link>
      <span class="text-indigo-400 font-medium">/</span> Vytvořit
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full" label="Název" />
          <text-input v-model="form.warranty" :error="form.errors.warranty" class="pb-8 pr-6 w-full lg:w-1/2" label="Záruka" />
          <text-input v-model="form.price" :error="form.errors.price" type="number" step="any" class="pb-8 pr-6 w-full lg:w-1/2" label="Cena" />
          <SelectInput v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full" label="Vyberte typ komponenty">
            <option v-for="(componentType, index) in componentTypes" :key="index" :value="index">{{ componentType }}</option>
          </SelectInput>
          <SelectInput v-model="form.group" :error="form.errors.group" class="pb-8 pr-6 w-full" label="Vyberte skupinu komponenty">
            <option v-for="(componentGroup, index) in componentGroups" :key="index" :value="index">{{ componentGroup }}</option>
          </SelectInput>
          <text-input v-model="form.power_cap" :error="form.errors.power_cap" type="number" step="any" class="pb-8 pr-6 w-full lg:w-1/2" label="Výkon nebo kapacita (kWp / kWh / kW)" />
          <text-area-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full" label="Popis" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Přidat komponentu</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextAreaInput from '@/Shared/TextAreaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextAreaInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    componentTypes: Object,
    componentGroups: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        description: null,
        warranty: null,
        type: null,
        group: null,
        power_cap: null,
        price: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/components')
    },
  },
}
</script>
